/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceCompanySelectionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto {
    return WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function WebApiServicesDataTransferObjectsUserServiceCompanySelectionDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceCompanySelectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

